import { request } from '../utils/request';
import type {
  PendingAlertsWidgetResponse,
  PendingAlertsWidgetParams,
  AnalyticsWidgetResponse,
  AnalyticsWidgetParams,
  OrganizationWidgetResponse,
  OrganizationWidgetParams,
} from '../types/dashboard.types';

export const getPendingAlerts = async (
  params: PendingAlertsWidgetParams,
): Promise<PendingAlertsWidgetResponse> => {
  const queryParams = new URLSearchParams();

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  if (params.accountUuid) {
    queryParams.append('account_uuid', params.accountUuid);
  }

  if (params.userUuid) {
    queryParams.append('user_uuid', params.userUuid);
  }

  const queryString = queryParams.toString();
  const url = `/dashboard/pending-alerts${
    queryString ? `?${queryString}` : ''
  }`;

  return await request<PendingAlertsWidgetResponse>(url, {
    method: 'GET',
  });
};

export const getAnalytics = async (
  params: AnalyticsWidgetParams,
): Promise<AnalyticsWidgetResponse> => {
  const queryParams = new URLSearchParams();

  queryParams.append('date_range', params.dateRange);

  if (params.accountUuid) {
    queryParams.append('account_uuid', params.accountUuid);
  }

  if (params.userUuid) {
    queryParams.append('user_uuid', params.userUuid);
  }

  const queryString = queryParams.toString();
  const url = `/dashboard/analytics${queryString ? `?${queryString}` : ''}`;

  return await request<AnalyticsWidgetResponse>(url, {
    method: 'GET',
  });
};

export const getOrganizationMembers = async (
  params: OrganizationWidgetParams,
): Promise<OrganizationWidgetResponse> => {
  const queryParams = new URLSearchParams();

  if (params.accountUuid) {
    queryParams.append('account_uuid', params.accountUuid);
  }

  if (params.userUuid) {
    queryParams.append('user_uuid', params.userUuid);
  }

  const queryString = queryParams.toString();
  const url = `/dashboard/organization-members${
    queryString ? `?${queryString}` : ''
  }`;

  return await request<OrganizationWidgetResponse>(url, {
    method: 'GET',
  });
};
